import { render, staticRenderFns } from "./UserTab.vue?vue&type=template&id=3de52618&"
import script from "./UserTab.vue?vue&type=script&lang=js&"
export * from "./UserTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports